export default __webpack_public_path__ + "static/media/noun-bond-3967567.d3cc6934.svg";